import { defineComponent as _defineComponent } from 'vue'
import { computed, ref } from 'vue';
import { faChevronDown } from '@fortawesome/free-solid-svg-icons';
import CheckboxInput from '@/ui-components/CheckboxInput.vue';


export default /*#__PURE__*/_defineComponent({
  __name: 'ListItemExpandable',
  props: {
    itemsCount: null,
    selectedItemsCount: { default: 0 },
    isInitiallyExpanded: { type: Boolean },
    enableToggleAll: { type: Boolean, default: true }
  },
  emits: ["toggleAllExtras"],
  setup(__props: any) {

const props = __props as { itemsCount: number, selectedItemsCount: number, isInitiallyExpanded: boolean, enableToggleAll: boolean };





const isExpanded = ref(props.isInitiallyExpanded);

const isAllSelected = computed(() => props.itemsCount === props.selectedItemsCount);

function onExpandToggle() {
	isExpanded.value = !isExpanded.value;
}

return { __sfc: true,props, isExpanded, isAllSelected, onExpandToggle, faChevronDown, CheckboxInput }
}

})